"use strict"

import React from "react"

import { withPlotSettingsConfig } from "../../../config/PlotSettingsConfigProvider"
import AnnotationLayerComment from "./AnnotationLayerComment"
import { withAnnotationsConfig } from "../../../config/AnnotationConfigProvider"

function VerticalDashedLine({
  x,
  y,
  arr,
  color,
  canToggleVisibility = false,
  timeExtractor, // From PlotSettingsConfigProvider
  annotation_visibility_state = {}, // From AnnotationConfigProvider
}) {
  const panelHeight = y.range()[0]

  return (arr || []).map((marker, i) => {
    const time = timeExtractor.name === "Day" ? marker.day : marker.timestamp
    let show_line = true
    let show_text = false
    if (canToggleVisibility) {
      const marker_state = annotation_visibility_state?.[marker.id]
      show_line = marker_state?.show_line
      show_text = marker_state?.show_text
    }
    return (
      <React.Fragment key={`annotation_${i}`}>
        {show_text && <AnnotationLayerComment x={x} panelHeight={panelHeight} marker={marker} />}
        {show_line && (
          <line
            key={`marker_${i}`}
            x1={x(time)}
            y1={0}
            x2={x(time)}
            y2={panelHeight}
            strokeDasharray="7 7 7 7"
            style={{ strokeWidth: "2" }}
            stroke={color}
            opacity={0.8}
          />
        )}
      </React.Fragment>
    )
  })
}

export default withPlotSettingsConfig(withAnnotationsConfig(VerticalDashedLine))
